import React from "react";
import PropTypes from "prop-types";
import { compose, setDisplayName, flattenProp } from "recompose";
import { format } from "date-fns";
import { connect } from "react-redux";
import { getUser } from "../modules/auth";

const Note = compose(
  setDisplayName("NoteListItem"),
  flattenProp("note"),
  flattenProp("user"),
  connect(state => ({ currentUser: getUser(state) }))
)(
  ({
    content,
    created_at,
    first_name,
    last_name,
    user,
    currentUser,
    children,
    img_urls,
    video_urls
  }) => (
    <div className="col-12 note">
      <div className="note-content">
        {content}
        {img_urls && img_urls.length > 0 && (
          <ul>
            {img_urls.map((image_url, index) => (
              <li key={index} className="list-unstyled">
                <a href={`${process.env.REACT_APP_API_URL}/${image_url}`} target="_blank" rel="noopener noreferrer">
                  <img src={`${process.env.REACT_APP_API_URL}/${image_url}`} alt="Note image" width="300" className="note-img" />
                </a>
              </li>
            ))}
          </ul>
        )}
        {video_urls && video_urls.length > 0 && (
          <div className="note-content-video">
            <ul>
              {video_urls.map((video_url, index) => (
                <li key={index} className="list-unstyled" >
                   <video width="320" height="240" controls>
                    <source src={`${process.env.REACT_APP_API_URL}/${video_url}`} type="video/mp4" />
                    <source src={`${process.env.REACT_APP_API_URL}/${video_url}`} type="video/ogg" />
                    Your browser does not support the video tag.
                  </video> 
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      
      <div className="text-muted">
        On: <i>{created_at || format(new Date(), "MM/DD/YYYY HH:mm")}</i>
        <br />
        By:{" "}
        {user
          ? `${first_name} ${last_name}`
          : `${currentUser.first_name} ${currentUser.last_name}`}
      </div>
    </div>
  )
);

const NoteList = ({ notes, children }) => {
  return (
    <div className="row">
      {notes.map(note => (
        <Note key={note.id} note={note}>
          {typeof children === "function" && children({ note })}
        </Note>
      ))}
    </div>
  );
};

NoteList.propTypes = {
  notes: PropTypes.array.isRequired,
  contract: PropTypes.object.isRequired,
  updateNote: PropTypes.func.isRequired
};

export default NoteList;
